import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {UserModel, userModelFactory} from "../types/user.model";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 10;

@Injectable()
export class UserService {
  private url: string = "/api/users";

  constructor(private http: HttpClient) {}

  getUsers(
    page = DEFAULT_PAGE,
    limit = DEFAULT_PAGE_LIMIT,
    search?: string,
    filterByFedLLC?: boolean,
    includeLinkableServiceAccounts?: boolean,
  ): Observable<any> {
    const params = {
      ...page && {page: `${page}`},
      ...limit && {limit: `${limit}`},
      ...search && {search},
      ...filterByFedLLC && {filterByFedLLC: `${filterByFedLLC}`},
      ...includeLinkableServiceAccounts && {includeLinkableServiceAccounts: "true"},
      sequence: "true",
    };

    return this.http.get<{rows: any[], count: any}>(`${this.url}`, {params})
      .pipe(map(({rows, count}) => ({rows, count})));
  }

  getUserById(id): Promise<any> {
    return this.http.get<{roles: any, userRoles: any, user: any}>(`${this.url}?id=${id || "new"}`)
      .pipe(map(({roles, userRoles, user}) => ({user: userModelFactory(user), userRoles, roles})))
      .toPromise();
  }

  saveUserWithRoles(user: UserModel, selectedRoles = []): Promise<string> {
    const params = {selectedRoles, ...user};
    return this.http.post(`${this.url}/save-with-roles`, params)
      .pipe(map(obj => obj["id"]))
      .toPromise();
  }

  switchUser(user = ""): Promise<boolean> {
    return this.http.post(`${this.url}/switch-user`, {user})
      .pipe(map(obj => !!obj["success"]))
      .toPromise();
  }

  getNewUserInfo(uid): Promise<UserModel> {
    return this.http.get(`${this.url}/new-user-info?uid=${uid}`)
      .pipe(map(userModelFactory))
      .toPromise();
  }
}
